module.exports = __webpack_public_path__ + "static/banner-venture-fa43852b8d93cfc441e2939cc0f05bd6.png";